// extracted by mini-css-extract-plugin
export default {"screenBlock":"AppSidebarSupport_screenBlock_Xw3gU"};